import api from "../api";

export const companiesService = {
  merge: async (companyIds, companyPayload = null) => {
    const res = await api.post("/api/persons/companies/merge/", {
      company_ids: companyIds,
      ...(companyPayload ? { company: companyPayload } : {}),
    });
    return res.data?.data ?? res.data;
  },

  list: async (params = {}) => {
    const res = await api.get("/api/persons/companies/", { params });
    const results = Array.isArray(res.data?.data) ? res.data.data : [];
    return {
      results,
      count: res.data?.count ?? results.length,
      next: res.data?.next ?? null,
      previous: res.data?.previous ?? null,
    };
  },

  getDetail: async (id) => {
    const res = await api.get(`/api/persons/companies/${id}/`);
    return res.data?.data ?? res.data;
  },

  create: async (payload) => {
    const res = await api.post("/api/persons/companies/", payload);
    return res.data?.data ?? res.data;
  },

  update: async (id, payload) => {
    const res = await api.patch(`/api/persons/companies/${id}/`, payload);
    return res.data?.data ?? res.data;
  },

  remove: async (id) => {
    const res = await api.delete(`/api/persons/companies/${id}/`);
    return res.data;
  },

  getPersons: async (id, params = {}) => {
    const res = await api.get(`/api/persons/companies/${id}/persons/`, { params });
    const results = Array.isArray(res.data?.data) ? res.data.data : [];
    return {
      results,
      count: res.data?.count ?? results.length,
      next: res.data?.next ?? null,
    };
  },
};
